/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as StandardRouteImport } from './routes/_standard'
import { Route as GanttRouteImport } from './routes/_gantt'
import { Route as UnauthorizedIndexRouteImport } from './routes/unauthorized/index'
import { Route as GanttIndexRouteImport } from './routes/_gantt/index'
import { Route as StandardDevIndexRouteImport } from './routes/_standard/dev/index'
import { Route as StandardTasksTaskIdIndexRouteImport } from './routes/_standard/tasks/$taskId/index'
import { Route as StandardBucketsBucketIdIndexRouteImport } from './routes/_standard/buckets/$bucketId/index'

const StandardRoute = StandardRouteImport.update({
  id: '/_standard',
  getParentRoute: () => rootRouteImport,
} as any)
const GanttRoute = GanttRouteImport.update({
  id: '/_gantt',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthorizedIndexRoute = UnauthorizedIndexRouteImport.update({
  id: '/unauthorized/',
  path: '/unauthorized/',
  getParentRoute: () => rootRouteImport,
} as any)
const GanttIndexRoute = GanttIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => GanttRoute,
} as any)
const StandardDevIndexRoute = StandardDevIndexRouteImport.update({
  id: '/dev/',
  path: '/dev/',
  getParentRoute: () => StandardRoute,
} as any)
const StandardTasksTaskIdIndexRoute =
  StandardTasksTaskIdIndexRouteImport.update({
    id: '/tasks/$taskId/',
    path: '/tasks/$taskId/',
    getParentRoute: () => StandardRoute,
  } as any)
const StandardBucketsBucketIdIndexRoute =
  StandardBucketsBucketIdIndexRouteImport.update({
    id: '/buckets/$bucketId/',
    path: '/buckets/$bucketId/',
    getParentRoute: () => StandardRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof GanttIndexRoute
  '/unauthorized/': typeof UnauthorizedIndexRoute
  '/dev/': typeof StandardDevIndexRoute
  '/buckets/$bucketId/': typeof StandardBucketsBucketIdIndexRoute
  '/tasks/$taskId/': typeof StandardTasksTaskIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof GanttIndexRoute
  '/unauthorized': typeof UnauthorizedIndexRoute
  '/dev': typeof StandardDevIndexRoute
  '/buckets/$bucketId': typeof StandardBucketsBucketIdIndexRoute
  '/tasks/$taskId': typeof StandardTasksTaskIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_gantt': typeof GanttRouteWithChildren
  '/_standard': typeof StandardRouteWithChildren
  '/_gantt/': typeof GanttIndexRoute
  '/unauthorized/': typeof UnauthorizedIndexRoute
  '/_standard/dev/': typeof StandardDevIndexRoute
  '/_standard/buckets/$bucketId/': typeof StandardBucketsBucketIdIndexRoute
  '/_standard/tasks/$taskId/': typeof StandardTasksTaskIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/unauthorized/'
    | '/dev/'
    | '/buckets/$bucketId/'
    | '/tasks/$taskId/'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/unauthorized' | '/dev' | '/buckets/$bucketId' | '/tasks/$taskId'
  id:
    | '__root__'
    | '/_gantt'
    | '/_standard'
    | '/_gantt/'
    | '/unauthorized/'
    | '/_standard/dev/'
    | '/_standard/buckets/$bucketId/'
    | '/_standard/tasks/$taskId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  GanttRoute: typeof GanttRouteWithChildren
  StandardRoute: typeof StandardRouteWithChildren
  UnauthorizedIndexRoute: typeof UnauthorizedIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_standard': {
      id: '/_standard'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof StandardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_gantt': {
      id: '/_gantt'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof GanttRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unauthorized/': {
      id: '/unauthorized/'
      path: '/unauthorized'
      fullPath: '/unauthorized/'
      preLoaderRoute: typeof UnauthorizedIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_gantt/': {
      id: '/_gantt/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof GanttIndexRouteImport
      parentRoute: typeof GanttRoute
    }
    '/_standard/dev/': {
      id: '/_standard/dev/'
      path: '/dev'
      fullPath: '/dev/'
      preLoaderRoute: typeof StandardDevIndexRouteImport
      parentRoute: typeof StandardRoute
    }
    '/_standard/tasks/$taskId/': {
      id: '/_standard/tasks/$taskId/'
      path: '/tasks/$taskId'
      fullPath: '/tasks/$taskId/'
      preLoaderRoute: typeof StandardTasksTaskIdIndexRouteImport
      parentRoute: typeof StandardRoute
    }
    '/_standard/buckets/$bucketId/': {
      id: '/_standard/buckets/$bucketId/'
      path: '/buckets/$bucketId'
      fullPath: '/buckets/$bucketId/'
      preLoaderRoute: typeof StandardBucketsBucketIdIndexRouteImport
      parentRoute: typeof StandardRoute
    }
  }
}

interface GanttRouteChildren {
  GanttIndexRoute: typeof GanttIndexRoute
}

const GanttRouteChildren: GanttRouteChildren = {
  GanttIndexRoute: GanttIndexRoute,
}

const GanttRouteWithChildren = GanttRoute._addFileChildren(GanttRouteChildren)

interface StandardRouteChildren {
  StandardDevIndexRoute: typeof StandardDevIndexRoute
  StandardBucketsBucketIdIndexRoute: typeof StandardBucketsBucketIdIndexRoute
  StandardTasksTaskIdIndexRoute: typeof StandardTasksTaskIdIndexRoute
}

const StandardRouteChildren: StandardRouteChildren = {
  StandardDevIndexRoute: StandardDevIndexRoute,
  StandardBucketsBucketIdIndexRoute: StandardBucketsBucketIdIndexRoute,
  StandardTasksTaskIdIndexRoute: StandardTasksTaskIdIndexRoute,
}

const StandardRouteWithChildren = StandardRoute._addFileChildren(
  StandardRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  GanttRoute: GanttRouteWithChildren,
  StandardRoute: StandardRouteWithChildren,
  UnauthorizedIndexRoute: UnauthorizedIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
